/** @format */

import React, {useState, useEffect} from 'react';
import {validateEmail} from '../../utils/postcodeValidation';
import {FormikControl, Form, Formik, Loader} from '@home-loan-experts/ui-helper';
import { RESULT_EMAIL_SENT_NOTICE } from '../../constants';
import {mailPostcode} from '../../actions';
import {useDispatch, useSelector} from 'react-redux';
import { isEmpty } from "../../utils";
import Notice from "../common/Notice";

const PostcodeEmail = () => {
    const postcode = useSelector((state) => state.postcode);
    const [showEmailInput, setEmailInput] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        //displaying email input field when postcode return's calculation
        //hidden input if postcode doesn't return's any value
        setEmailInput(!!postcode.status);
    }, [postcode]);

    const handleSubmit = (values, {setSubmitting, resetForm}) => {
        dispatch(mailPostcode(values))
            .then(() => {})
            .finally(() => {
                setEmailInput(false);
                setSubmitting(false);
                resetForm();
            });
    };
    //only displays success email for now
    const showAlert = () => {
        const handleEnquiryLinkClick = (e) => {
            e.preventDefault();
            setEmailInput(true);
        };

        return <Notice message={RESULT_EMAIL_SENT_NOTICE} onLinkClick={handleEnquiryLinkClick} />;
    };
    return (
        <>
            <div className="emailResult">
                {!showEmailInput && showAlert()}
                {showEmailInput && (
                    <Formik
                        initialValues={{
                            email: ''
                        }}
                        validationSchema={validateEmail}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, values }) => (
                            <Form autoComplete="off">
                                <div className="email-input">
                                    <FormikControl
                                        control="input"
                                        type="email"
                                        label="Want a copy of this result? Enter your email below"
                                        name="email"
                                        disabled={isSubmitting}
                                        placeholder="Enter your email address"
                                        tooltipProps={{
                                            tooltipDisabled: true
                                        }}
                                        
                                    />
                                </div>
                                <button
                                    className={`clear-btn btn btn-white loading-btn email-btn ${isSubmitting? 'btn--is-submitting':""}`}
                                    type="submit"
                                    disabled={isSubmitting || values.email === '' || isEmpty(values)}
                                >
                                    Email the results <Loader isLoading={isSubmitting} />
                                </button>
                            </Form>
                        )}
                    </Formik>
                )}
            </div>
        </>
    );
};

export default PostcodeEmail;
